import { isRecordEmpty } from 'hx-util';
import { useEffect, useState } from 'react';
export var useDominantSpeaker = function (_a) {
    var room = _a.room;
    var _b = useState({}), dominantSpeaker = _b[0], setDominantSpeaker = _b[1];
    useEffect(function () {
        if (isRecordEmpty(room))
            return;
        var handleDominantSpeakerChanged = function (participant) {
            return setDominantSpeaker(participant);
        };
        room.on('dominantSpeakerChanged', handleDominantSpeakerChanged);
        return function () {
            room.off('dominantSpeakerChanged', handleDominantSpeakerChanged);
        };
    }, [room]);
    return { dominantSpeaker: dominantSpeaker };
};
